export const ENDPOINT = {
  PUBLIC: {
    HOME: '/',
    LOGIN: '/login',
    REGISTER: '/register',
    PRODUCTS: '/api/products?limit=5',
  },
  PRIVATE: {
    DASHBOARD: '/dashboard',
    PROFILE: '/profile',
    SETTINGS: '/settings',
  },
  DUMMY: {
    USERS: '/data/users.json',
    PRODUCTS: '/data/products.json',
  },
};
